import MainContainer from '../../layout/container/MainContainer';

export function ProductPage() {
    return (
        <MainContainer section="transactions" secondarySection="product">
            <div className="title">Product</div>
        </MainContainer>
    );
}
